// Asset management app composable

import { computed, onMounted, watch, onBeforeMount } from "vue";
import { SmxMenu, useMenuStore } from "@shared/stores/menu";
import { useTwinEditCreateStore } from "@shared/stores/twinCreateEdit";
import { useI18n } from "vue-i18n";
import { useAuthStore } from "../stores/auth";
import { useRouter } from "vue-router";

export function useAssetManagementAdmin() {
  const { t } = useI18n();

  // Set the navigation menu
  const menuStore = useMenuStore();
  const router = useRouter();
  const authStore = useAuthStore();

  onBeforeMount(() => {
    const roles = authStore.rolesByClientId?.["smx-model-mgmt"]?.roles;
    const menuContent = [];
    if (roles.some((val) => val === "user" || val === "admin")) {
      menuContent.push({
        id: "twintemplate.list",
        name: t("templateManagement"),
        type: "routerlink" as const,
        route: { name: "assetAdmin" },
      });
      menuContent.push({
        id: "facetTransitions",
        name: t("facetTransitions"),
        type: "routerlink" as const,
        route: { name: "facetTransitions" },
      });
      menuContent.push({
        id: "permissions",
        name: t("Permissions"),
        type: "routerlink" as const,
        route: { name: "permissions" },
      });

      menuContent.push({
        id: "databaseManagement",
        name: t("databaseManagement"),
        type: "routerlink" as const,
        route: { name: "modelAdminDatabases" },
      });
    } else if (roles.some((val) => val === "steward")) {
      // If the user only has the steward role, we have to dynamically change the base route to input values.
      // If the user also is currently on the base route, we also have to reload the route
      const baseRoute = router
        .getRoutes()
        .find((item) => item.name === "assetAdmin");
      if (!baseRoute.meta.isInputValues) {
        router.removeRoute("assetAdmin");
        router.addRoute({
          path: "/asset-admin",
          name: "assetAdmin",
          component: () =>
            import("@shared/components/twinManagement/InputValueAdmin.vue"),
          meta: {
            isInputValues: true,
            appClientId: "smx-model-mgmt",
            breadcrumbs: [
              {
                label: "inputValues",
                route: { name: "assetAdmin" },
              },
            ],
          },
        });
        // If the route wasn't input values and it was tried to access the app base route, we have to reload
        if (router.currentRoute.value.name === "assetAdmin") {
          router.push({ name: "assetAdmin" });
        }
      }
    }

    menuContent.push({
      id: "twintemplate.inputvalues",
      name: t("manageInputValues"),
      type: "routerlink" as const,
      route: { name: "assetAdminInputValues" },
    });

    menuStore.setMenu({
      content: menuContent,
    });
  });
}
